import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFishing = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M11.2315 5.94116V10.8824C11.2315 11.9745 10.7979 13.0218 10.0261 13.7941C9.2542 14.5663 8.20734 15.0001 7.11577 15.0001C6.0242 15.0001 4.97734 14.5663 4.20548 13.7941C3.43362 13.0218 3 11.9745 3 10.8824V7.58824L5.46946 10.0589",
			stroke: "white",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.58972 4.29405C9.58972 4.73089 9.76317 5.14983 10.0719 5.45872C10.3807 5.7676 10.7994 5.94113 11.236 5.94113C11.6727 5.94113 12.0914 5.7676 12.4001 5.45872C12.7089 5.14983 12.8823 4.73089 12.8823 4.29405C12.8823 3.85722 12.7089 3.43828 12.4001 3.12939C12.0914 2.8205 11.6727 2.64697 11.236 2.64697C10.7994 2.64697 10.3807 2.8205 10.0719 3.12939C9.76317 3.43828 9.58972 3.85722 9.58972 4.29405Z",
			stroke: "white",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.2372 2.64708V1",
			stroke: "white",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgFishing;
